import React from "react";
import { Link } from "react-router-dom";

import ICONS from "../../constants/icons";

import { WholeWrapper } from "./components";

const Controls = () => {
  return (
    <WholeWrapper>
      <Link to="/">
        <ICONS.SidebarProfile width="32px" height="32px" opacity="0.5" />
      </Link>
      <Link to="/">
        <ICONS.SidebarSettings />
      </Link>
    </WholeWrapper>
  );
};

export default Controls;
